export function panelActionsHostId(panelId: string): string {
  return `panel-actions-${panelId}`
}
